import React, { useState } from 'react';
import { Page, Header, Content } from '@backstage/core-components';
import Tab from '@material-ui/core/Tab';
import { makeStyles } from '@material-ui/core/styles';
import TabContext from '@material-ui/lab/TabContext';
import TabList from '@material-ui/lab/TabList';
import TabPanel from '@material-ui/lab/TabPanel';
import { FailedEntities } from './FailedEntities.esm.js';
import { PendingEntities } from './PendingEntities.esm.js';

const useStyles = makeStyles(() => ({
  tabPanel: {
    paddingLeft: "0px",
    paddingRight: "0px"
  }
}));
const UnprocessedEntitiesContent = () => {
  const classes = useStyles();
  const [tab, setTab] = useState("failed");
  const handleChange = (_event, tabValue) => {
    setTab(tabValue);
  };
  return /* @__PURE__ */ React.createElement(TabContext, { value: tab }, /* @__PURE__ */ React.createElement(TabList, { onChange: handleChange }, /* @__PURE__ */ React.createElement(Tab, { label: "Failed", value: "failed" }), /* @__PURE__ */ React.createElement(Tab, { label: "Pending", value: "pending" })), /* @__PURE__ */ React.createElement(TabPanel, { value: "failed", className: classes.tabPanel }, /* @__PURE__ */ React.createElement(FailedEntities, null)), /* @__PURE__ */ React.createElement(TabPanel, { value: "pending", className: classes.tabPanel }, /* @__PURE__ */ React.createElement(PendingEntities, null)));
};
const UnprocessedEntities = () => {
  return /* @__PURE__ */ React.createElement(Page, { themeId: "tool" }, /* @__PURE__ */ React.createElement(Header, { title: "Unprocessed Entities" }), /* @__PURE__ */ React.createElement(Content, null, /* @__PURE__ */ React.createElement(UnprocessedEntitiesContent, null)));
};

export { UnprocessedEntities, UnprocessedEntitiesContent };
//# sourceMappingURL=UnprocessedEntities.esm.js.map
